import React, { useState } from "react";
import { Table } from "antd";
import { computeRowsAndCols } from "../../../pages/fleet/utils/functions";
import { useNavigate } from "react-router-dom";
import { Fleets } from "pages/fleet/Fleets";
import useWindowDimensions from "common/functions";

interface ITable {
	data: Fleets
	selectedFilter?: string;
	setNewSort: (value: string) => void;
	shouldReset: (value: boolean) => void;
	reset: boolean;
	offset: number;
	setOffset: (value: number) => void;
	limit: number;
	length: number;
}

const FleetsTable: React.FC<ITable> = ({
	offset,
	setOffset,
	data,
	setNewSort,
	shouldReset,
	reset,
	length,
	limit
}) => {
	const navigate = useNavigate();

	const { width } = useWindowDimensions();

	const [isAsc, setIsAsc] = useState({ totalEnergyKWh: false, totalSessions: false });
	const [isDesc, setIsDesc] = useState({ totalEnergyKWh: false, totalSessions: false });

	let { columns, rows } = computeRowsAndCols(data.map((item:any)=>{return {...item,fleetId:item.chargerId}}),
		navigate,
		(value) => setNewSort(value),
		shouldReset,
		reset,
		isAsc,
		isDesc,
		(value) => setIsAsc(value),
		(value) => setIsDesc(value)
	);

	return (
		<Table columns={columns} dataSource={rows} size={width > 1600 ? 'large' : (width > 1200 ? 'middle' : 'small')}
			scroll={{ x: 500 }}
			pagination={{
				total: length,
				current: offset + 1,
				onChange: (page) => setOffset(page - 1),
				defaultPageSize: Number(limit),
				showSizeChanger: false
			}}
			bordered />
	);
};

export default FleetsTable;
